<template>
  <header>
    <div class="d-flex flex-row justify-content-between">
      <div class="align-self-center">
        <button type="button"
                class="menu-button"
                data-bs-toggle="modal"
                data-bs-target="#menuNavigationModal">
          <font-awesome-icon :icon="['fas', 'bars']"></font-awesome-icon>
          <span>menu</span>
        </button>
      </div>
      <div class="align-self-center">
        <router-link to="/" class="d-flex flex-row">
          <div class="align-self-center">
            <img class="img-fluid" alt="logo info texto" src="../../assets/img/logo.png">
          </div>
          <h1 class="m-0 align-self-center">INFO TEXTO</h1>
        </router-link>
      </div>
      <div class="align-self-center" v-if="$route.path.slice(1) !== 'connection'">
        <button type="button"
                @click="connectDisconnect()"
                :class="getUtilisateurToken ? 'connection-button-on' : 'connection-button-off'">
          <font-awesome-icon class="icon-power-off" :icon="['fas', 'power-off']"></font-awesome-icon>
        </button>
        <div :class="getUtilisateurToken ? 'deconnecte' : 'connecte'">
          {{ getUtilisateurToken ? 'Cliquez ici pour vous déconnecter' : 'Cliquez ici pour vous connecter' }}
        </div>
      </div>
      <div v-else>&nbsp;</div>
    </div>
    <aside class="modal fade" id="menuNavigationModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header d-flex flex-row justify-content-end">
            <button type="button" class="" data-bs-dismiss="modal">
              <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <nav class="d-flex flex-row flex-wrap justify-content-between">
                <span class="d-none">{{selectedRoute}}</span>
                <template v-for="menu in getMenu">
                  <router-link class="routerLink"
                               :to="menu.path"
                               exact
                               v-if="$route.path !== menu.path">
                    <button :class="'bButton ' + menu.class"
                            @click="selectedRoute = menu.path.slice(1)"
                            data-bs-dismiss="modal">
                      <font-awesome-icon class="icon-menu" :icon="menu.icon"></font-awesome-icon>
                      <span class="d-block">{{ menu.titre }}</span>
                    </button>
                  </router-link>
                </template>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </header>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  name: "Header",
  props: {},
  components: {},
  data(){
    return{
      selectedRoute: ''
    }
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
        'axiosUtilisateurDeconnection'
    ]),
    connectDisconnect(){
      if(this.getUtilisateurToken){
        this.axiosUtilisateurDeconnection()
        switch (this.getCurrentRoute){
          case '/historique-sms':
          case '/mon-compte':
          case '/mes-contacts':
          case '/nouveau-sms':
            this.$router.replace(this.getPrevRoute).then()
          break;
        }
      }else {
        this.$router.push('connection')
      }
    }
  },
  computed: {
    ...mapGetters([
      'getMenu',
      'getUtilisateurToken',
      'getPrevRoute',
      'getCurrentRoute',
    ]),
  },
  watch: {
    selectedRoute: function () {
      let vm = this;
      if(vm.selectedRoute === ''){
        this.$router.push('/')
      }else {
        this.$router.push(vm.selectedRoute)
      }
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
header{
  color: var(--color-second);
  background: var(--color-first);
  background-image: url(../../assets/img/bg-9.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  & > div{
    padding: 1rem .5rem;
    background: var(--color-first-0-5);
    & > div:nth-child(1){}
    & > div:nth-child(2){
      & > a{
        text-decoration: none;
        color: var(--color-second);
        & > div{
          margin-right: .5rem;
          & > img{
            width: 3.5rem;
          }
        }
        & > h1{
          font-size: x-large;
        }
      }
    }
    & > div:nth-child(3){
      .connection-button-off, .connection-button-on{
        & > .icon-power-off{
          font-size: x-large;
        }
      }
      .connection-button-off:hover + div.connecte,
      .connection-button-on:hover + div.connecte,
      .connection-button-off:hover + div.deconnecte,
      .connection-button-on:hover + div.deconnecte{
        display: block;
      }
      & > div{
        display: none;
        position: absolute;
        top: 4.5rem;
        right: 0;
        padding: .4rem 1rem;
        z-index: 1;
      }
      & > div.connecte{
        background: var(--color-eighth-0-5);
      }
      & > div.deconnecte{
        background: var(--color-fifth-0-5);
      }
    }
  }
  & > aside.modal{
    color: var(--color-first);
    & > div.modal-dialog{
      & > div.modal-content{
        background: transparent;
        border: none;
        & > div.modal-header{
          border: none;
          & > button{
            border-color: var(--color-second);
            background: var(--color-fifth);
            color: var(--color-second);
            border-radius: .3rem;
          }
          & > button:hover{
            background: transparent;
            color: var(--color-second);
          }
        }
        & > div.modal-body{
          background: var(--color-first);
          border-radius: .8rem;
          background-image: url(../../assets/img/bg-4.png);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          padding: 0;
          & > div{
            background: var(--color-first-0-5);
            height: 100%;
            & > nav{
              padding: .5rem 2rem;
              & > .routerLink{
                margin: .5rem;
                & > .bButton{
                  width: 120px;
                  height: 100px;
                  color: var(--color-first);
                  border-color: var(--color-second);
                  border-radius: .8rem;
                  padding: 1rem;
                  & > .icon-menu{
                    font-size: 1.5rem;
                  }
                  & > span{
                    font-size: x-small;
                    font-weight: bold;
                    text-transform: uppercase;
                    margin-top: .5rem;
                  }
                }
              }
              & > .routerLink:hover{
                & > .bButton{
                  background: transparent;
                  color: var(--color-second);
                  & > .icon-menu{}
                  & > span{}
                }
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 576px) {
  header{
    & > div{
      & > div:nth-child(1){}
      & > div:nth-child(2){
        & > a{
          & > div{
            & > img{}
          }
          & > h1{
            font-size: xx-large;
          }
        }
      }
      & > div:nth-child(3){
        .connection-button{
          & > .icon-power-off{
          }
        }
        .connection-button:hover{
          & > .icon-power-off{}
        }
      }
    }
    & > aside.modal{
      & > div.modal-dialog{
        & > div.modal-content{
          & > div.modal-header{
            & > button{}
            & > button:hover{}
          }
          & > div.modal-body{
            & > div{
              & > nav{
                & > .routerLink{
                  & > .bButton{
                    & > .icon-menu{}
                    & > span{}
                  }
                }
                & > .routerLink:hover{
                  & > .bButton{
                    & > .icon-menu{}
                    & > span{}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 768px) {
  header{
    & > div{
      & > div:nth-child(1){}
      & > div:nth-child(2){
        & > div{
          & > img{}
        }
        & > a{
          & > h1{}
        }
      }
      & > div:nth-child(3){
        .connection-button{
          & > .icon-power-off{
          }
        }
        .connection-button:hover{
          & > .icon-power-off{}
        }
      }
    }
    & > aside.modal{
      & > div.modal-dialog{
        max-width: 700px;
        & > div.modal-content{
          & > div.modal-header{
            & > button{}
            & > button:hover{}
          }
          & > div.modal-body{
            & > div{
              & > nav{
                padding: .5rem 2rem;
                & > .routerLink{
                  margin: .5rem;
                  & > .bButton{
                    width: 175px;
                    height: 120px;
                    padding: 1rem;
                    & > .icon-menu{
                      font-size: 2rem;
                    }
                    & > span{
                      font-size: medium;
                      margin-top: 1.2rem;
                    }
                  }
                }
                & > .routerLink:hover{
                  & > .bButton{
                    & > .icon-menu{}
                    & > span{}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  header{
    & > div{
      & > div:nth-child(1){}
      & > div:nth-child(2){
        & > div{
          & > img{}
        }
        & > a{
          & > h1{}
        }
      }
      & > div:nth-child(3){
        .connection-button{
          & > .icon-power-off{
          }
        }
        .connection-button:hover{
          & > .icon-power-off{}
        }
      }
    }
    & > aside.modal{
      & > div.modal-dialog{
        max-width: 800px;
        & > div.modal-content{
          & > div.modal-header{
            & > button{}
            & > button:hover{}
          }
          & > div.modal-body{
            & > div{
              & > nav{
                padding: .5rem 2rem;
                & > .routerLink{
                  margin: .5rem;
                  & > .bButton{
                    width: 175px;
                    height: 120px;
                    padding: 1rem;
                    & > .icon-menu{
                      font-size: 2rem;
                    }
                    & > span{
                      font-size: medium;
                      margin-top: 1.2rem;
                    }
                  }
                }
                & > .routerLink:hover{
                  & > .bButton{
                    & > .icon-menu{}
                    & > span{}
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 1200px) {}

</style>



// WEBPACK FOOTER //
// src/components/shared/Header.vue